import axios from "axios";
import { baseURL, config, requestID } from "../../common/utils";






export const getProjectDetail = async (projectId) => {

  const payload = {
    requestID: requestID(),
    project_id:projectId

  }
  try {
    const response = await axios.post(`${baseURL}projects/getProjectById`, payload, config)
    return response.data;
  } catch (error) {
    console.error('Error fetching job:', error);
    return null;
  }
};
export const getProjects = async () => {

  const payload = {
    requestID: requestID(),

  }
  try {
    const response = await axios.post(`${baseURL}projects/getAllProjects`, payload, config)
    return response.data;
  } catch (error) {
    console.error('Error fetching job:', error);
    return null;
  }
};

export const getProjectsByAssingment = async () => {

  const payload = {
    requestID: requestID(),

  }
  try {
    const response = await axios.post(`${baseURL}projects/getProjectsByAssingment`, payload, config)
    return response.data;
  } catch (error) {
    console.error('Error fetching job:', error);
    return null;
  }
};


export const getProjectJobsAndApplicants = async (projectId) => {

  const payload = {
    requestID: requestID(),
    project_id:projectId

  }
  try {
    const response = await axios.post(`${baseURL}projects/getApplicantByProject`, payload, config)
    console.log({response})
    return response.data;
  } catch (error) {
    console.error('Error fetching job:', error);
    return null;
  }
};
export const getProjectJobs = async (projectId) => {

  const payload = {
    requestID: requestID(),
    project_id:projectId

  }
  try {
    const response = await axios.post(`${baseURL}projects/getJobRolesByProjectId`, payload, config)
    console.log({response})
    return response.data;
  } catch (error) {
    console.error('Error fetching job:', error);
    return null;
  }
};


export const getApplicantByProject = async (id) => {

  const payload = {
    requestID: requestID(),
    project_id:id

  }
  try {
    const response = await axios.post(`${baseURL}projects/getApplicantByProject`, payload, config)
    return response.data;
  } catch (error) {
    console.error('Error fetching job:', error);
    return null;
  }
};
export const getJobApplicantByJobRole = async (payload) => {

  const data = {
    requestID: requestID(),...payload

  }
  try {
    const response = await axios.post(`${baseURL}projects/getJobApplicantByProject`, data, config)
    console.log({response})
    return response.data;
  } catch (error) {
    console.error('Error fetching job:', error);
    return null;
  }
};

export const updateApplicantStatus = async () => {

  const payload = {
    requestID: requestID(),

  }
  try {
    const response = await axios.post(`${baseURL}projects/getAllProjects`, payload, config)
    return response.data;
  } catch (error) {
    console.error('Error fetching job:', error);
    return null;
  }
};
export const updateSelectedApplicants = async (data) => {

  const payload = {
    requestID: requestID(),...data

  }
  try {
    const response = await axios.post(`${baseURL}projects/updateSelectedApplicants`, payload, config)
    return response.data;
  } catch (error) {
    console.error('Error fetching job:', error);
    return null;
  }
};





export const sendApplicantToEndpoint = async () => {

  const payload = {
    requestID: requestID(),

  }
  try {
    const response = await axios.post(`${baseURL}projects/getAllProjects`, payload, config)
    return response.data;
  } catch (error) {
    console.error('Error fetching job:', error);
    return null;
  }
};